(function ($) {

    $(document).ready(function () {
        $('.button-collapse').click(function (e) {
            e.preventDefault();
            $('.sidebar-nav').toggleClass('active');
            $('.canvas .overlay').toggleClass('active');
            $('.canvas').toggleClass('active');
        });


        $('.canvas .overlay').click(function (e) {
            if ($(this).hasClass('active')) {
                $('.button-collapse').trigger('click');
            }
        });

        $('.navbar-right  .dropdown').hover(function () {
            $(this).find('.navbar-right .dropdown-menu').first().stop(true, true).delay(250).slideDown();

        }, function () {
            $(this).find('.navbar-right .dropdown-menu').first().stop(true, true).delay(100).slideUp();

        });

        $('.navbar-right .dropdown > a').click(function () {
            location.href = this.href;
        });

        $('.sidebar-menu .dropdown').each(function () {
            $(this).on('show.bs.dropdown', function () {
                $(this).find(' > a.dropdown-toggle').removeAttr('data-toggle');
                $(this).siblings('.open').removeClass('open').find('a.dropdown-toggle').attr('data-toggle', 'dropdown');
            });
        });

    });

}(jQuery));